import RoutesOnTick from "./api-ontick.routes";
// import RoutesMD from "./routes_md";

// export default Object.assign(RoutesOnTick, RoutesMD);
export default RoutesOnTick;
